


























import { CreateElement } from "vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "domains-provider": () =>
      import("@/components/app/admin/domains/domainsProvider.vue"),
    "domains-grid": () =>
      import("@/components/app/admin/domains/domainsGrid.vue")
  }
})
export default class AdminDomainsView extends Vue {
  public get desc() {
    return {
      render: (h: CreateElement) =>
        h(
          "div",
          { class: "content" },
          [
            "_sentence.custom_domain.settings_context",
            "_sentence.custom_domain.trusted_domains_desc",
            "_sentence.custom_domain.pointed_domains_desc"
          ].map(key => h("p", this.$t(key) as string))
        )
    };
  }
}
